import React, {useEffect, useState} from 'react';
import Pane from "./Pane";
import {JOURNEYS} from "../constants";
import FormInput from "./Forms/FormInput";
import SecondaryTitle from "./SecondaryTitle";
import Button from "./Button";
import InvisiblePane from "./InvisiblePane";
import BackButton from "./BackButton";

const AgentPanel = (props) => {
    const {
        hidden      = false,
        journey     = JOURNEYS.AGENT,
        disabled    = false,
    } = props;

    const [agent, setAgent] = useState(null);

    useEffect(() => {
        agentDetails();
    }, []);

    const agentDetails = () => {
        axios.get(route('web-api.agent.get').toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    setAgent(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const handleNewSession = () => {
        let confirmed = confirm('Are you sure you want to start a new session? Your progress within this journey will be lost.')

        if (confirmed) {
            if (journey === JOURNEYS.MANGO) {
                window.location.href = route('mango.session.missing').toString();
                return;
            }

            window.location.href = route('agent.session.missing').toString();
        }
    }

    const handleLogout = () => {
        let confirmed = confirm('Are you sure you want to logout? You will need to provide your access details again and your progress within this journey will be lost.')

        if (confirmed) {
            window.location.href = route('logout').toString();
        }
    }

    if (hidden || !agent || !agent.uuid || agent.uuid === '') {
        return null;
    }

    return (
        <React.Fragment>
            <Pane style={{marginTop: '29px'}}>
                <SecondaryTitle>{journey === JOURNEYS.AGENT ? 'Agent details' : 'Mango details'}</SecondaryTitle>
                <div className={'row m-0 p-0'}>
                    <div className="col-12 col-md-6 m-0 p-0 pe-md-2">
                        <FormInput
                            name={'agent_first_name'}
                            label={'First name'}
                            value={agent.first_name}
                            type={'text'}
                            onChange={(value) => ''}
                            disabled={true}
                            error={null}
                        />
                    </div>
                    <div className="col-12 col-md-6 m-0 p-0 ps-md-2">
                        <FormInput
                            name={'agent_last_name'}
                            label={'Last name'}
                            value={agent.last_name}
                            type={'text'}
                            onChange={(value) => ''}
                            disabled={true}
                            error={null}
                        />
                    </div>
                    <div className={'row m-0 p-0'}>
                        <div className="col-6 m-0 p-0 pe-2">
                            <BackButton
                                disabled={disabled}
                                onClick={() => handleLogout()}
                                hideIcons={true}
                                label={'Logout'}
                                style={{minHeight: '30px'}}
                            />
                        </div>
                        <div className="col-6 m-0 p-0 ps-2 d-flex justify-content-end">
                            <BackButton
                                disabled={disabled}
                                onClick={() => handleNewSession()}
                                hideIcons={true}
                                label={'New Session'}
                                style={{textAlign: 'right', minHeight: '30px'}}
                            />
                        </div>
                    </div>
                </div>
            </Pane>
        </React.Fragment>
    );
}

export default AgentPanel;
